/** Append a PDF page anchor so the browser's viewer opens at the statement
 *  section instead of page 1. Blob URLs and normal URLs both support #page=N. */
export function withPdfPage(url: string | null, page?: number | null): string | null {
  if (!url) return null;
  const base = url.split('#')[0];
  const target = typeof page === 'number' && Number.isFinite(page) && page > 0
    ? Math.floor(page)
    : 1;
  return `${base}#page=${target}`;
}
